import React, { useEffect, useState } from 'react';

const ProgressBar = ({ progress }) => {
    const [currentProgress, setCurrentProgress] = useState(0);

    useEffect(() => {
        if (currentProgress < progress) {
            const interval = setInterval(() => {
                setCurrentProgress((prevProgress) => {
                    if (prevProgress >= progress) {
                        clearInterval(interval);
                        return progress;
                    }
                    return prevProgress + 1;
                });
            }, 30); 
            return () => clearInterval(interval); 
        }
    }, [progress, currentProgress]);

    const progressColor = currentProgress === 100 ? '#94CDFF' : '#FFADAC';

    return (
        <div className="progress-container">
            <div
                className="progress-bar"
                style={{
                    width: `${currentProgress}%`,
                    backgroundColor: progressColor,
                }}
            />
            <div className="progress-percentage">
                {`${currentProgress}%`}
            </div>
        </div>
    );
};

export default ProgressBar;
